<template>
  <Modal
    v-model="abnormalModalVisible"
    @on-cancel="closeMatchModal"
    :mask-closable="false"
    title="云途异常处理"
    width="900px"
    @on-visible-change="visibleHand"
  >
    <div class="abnormal-modal-main">
      <Form ref="abnormalFormRef" class="abnormal-modal-form" :model="formData" :rules="formRule" :label-width="120">
        <div class="abnormal-tips-txt" v-if="viewKey == 'packageAbandon'">
          确定是否下达“弃件”指令？
        </div>
        <div class="abnormal-tips-txt" v-if="viewKey == 'packageReturn'">
          确定是否下达“退回”指令？
        </div>
        <div class="abnormal-tips-txt" v-if="viewKey == 'packageRead'">
          标记为已读后，异常不再进行提醒
        </div>
        <div class="abnormal-tips-txt" v-if="viewKey == 'packageIgnore'">
          <div>确定忽略该异常？</div>
          <div>忽略后该异常不再进行提醒</div>
        </div>
        <!-- 重派 -->
        <div v-if="viewKey == 'packageReassign'">
          <div>
            <Form-item label="重派类型" prop="retryType">
              <RadioGroup v-model="formData.retryType">
                <Radio :label="1">原址重派</Radio>
                <Radio :label="2">换址重派</Radio>
              </RadioGroup>
            </Form-item>
          </div>
          <div v-if="[2, '2'].includes(formData.retryType)">
            <div class="two-col-grid">
              <Form-item label="收件人姓名" prop="firstName">
                <Input v-model="formData.firstName" placeholder="请输入收件人姓名" />
              </Form-item>
              <Form-item label="收件人省州" prop="province">
                <Input v-model="formData.province" placeholder="请输入收件人省州" />
              </Form-item>
              <Form-item label="收件人城市" prop="city">
                <Input v-model="formData.city" placeholder="请输入收件人城市" />
              </Form-item>
              <Form-item label="收件人邮编" prop="postalCode">
                <Input v-model="formData.postalCode" placeholder="请输入收件人邮编" />
              </Form-item>
              <Form-item label="手机人联系电话" prop="phoneNumber">
                <Input v-model="formData.phoneNumber" placeholder="请输入手机人联系电话" />
              </Form-item>
            </div>
            <Form-item label="收件人详细地址" prop="addressLines">
              <Input
                type="textarea"
                v-model="formData.addressLines"
                placeholder="请输入收件人详细地址"
                :autosize="{ minRows: 3, maxRows: 6 }"
              />
            </Form-item>
          </div>
        </div>
        <!-- 放行 -->
        <div v-if="viewKey == 'packageRelease'">
          <div>
            <Form-item label="放行类型" prop="extraCodes">
              <RadioGroup v-model="formData.extraCodes">
                <Radio label="202">放行</Radio>
                <Radio label="205">分箱后放行</Radio>
                <Radio label="204">合箱后放行</Radio>
                <Radio label="206">加固后放行</Radio>
                <Radio label="203">更换包装后放行</Radio>
              </RadioGroup>
            </Form-item>
            <Form-item label="" v-if="formData.extraCodes == '202'">
              <div class="abnormal-error-tips">纯放行，不需要对包裹做增值操作(分箱、合箱、加固、更换包装)</div>
            </Form-item>
            <Form-item label="" v-if="formData.extraCodes == '206'">
              <div class="abnormal-error-tips">对原包裹做加固处理</div>
            </Form-item>
            <Form-item label="" v-if="formData.extraCodes == '203'">
              <div class="abnormal-error-tips">对原包裹做更换包装处理</div>
            </Form-item>
          </div>
          <div v-if="['204', '205'].includes(formData.extraCodes)">
            <Form-item label="云途单号" prop="newWaybillNumbers">
              <Input
                type="textarea"
                v-model="formData.newWaybillNumbers"
                placeholder="请输入云途单号，多个回车或逗号分隔"
                :autosize="{ minRows: 3, maxRows: 6 }"
              />
            </Form-item>
            <Form-item label="" v-if="formData.extraCodes == '205'">
              <div class="abnormal-error-tips">A. 提供一个新预报的可走货的单号时，表示原包裹用新的单号走货</div>
              <div class="abnormal-error-tips">B. 提供多个新预报的可走货的单号时，表示原包裹拆分成多个新的单号走货</div>
            </Form-item>
          </div>
        </div>
        <!-- 换单 -->
        <div v-if="viewKey == 'packageSwitch'">
          <div>
            <Form-item label="换单云途单号" prop="newWaybillNumber">
              <Input style="width: 50%;" v-model="formData.newWaybillNumber" placeholder="请输入云途单号" />
            </Form-item>
          </div>
        </div>
      </Form>
      <Spin fix v-if="pageLoading"></Spin>
    </div>
     <div slot="footer">
      <Button @click="closeMatchModal(false)">取消</Button>
      <Button type="primary" class="ml10" @click="packageAbnormalHand" :disabled="pageLoading">确定</Button>
    </div>
  </Modal>
</template>

<script>
import api from '@/api/api';

export default {
  mixins: [],
  props: {
    modalVisible: {
      type: Boolean,
      default: false
    },
    modalData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      abnormalModalVisible: false,
      pageLoading: false,
      formData: {
        extraCodes: '', // 放行类型
        newWaybillNumbers: null, // 放行时 云途单号
        newWaybillNumber: '', // 换单时 云途单号
        retryType: 1, // 重派类型。枚举(1：原址重派 2：换址重派)
        firstName: '', // 收件人名
        province: '', // 省州
        city: '', // 城市
        addressLines: '', // 地址
        postalCode: '', // 邮编
        phoneNumber: '', // 联系电话
      },
      formRule: {
        extraCodes: [
          { required: true, validator: this.$common.formItemVerify, trigger: 'change', msg: '选择放行类型' }
        ],
        newWaybillNumbers: [
          { required: true, validator: this.$common.formItemVerify, trigger: 'blur', msg: '请输入云途单号，多个回车或逗号分隔' },
          { required: true, validator: this.$common.formItemVerify, trigger: 'change', msg: '请输入云途单号，多个回车或逗号分隔' }
        ],
        newWaybillNumber: [
          { required: true, validator: this.$common.formItemVerify, trigger: 'blur', msg: '请输入云途单号' },
          { required: true, validator: this.$common.formItemVerify, trigger: 'change', msg: '请输入云途单号' }
        ],
        retryType: [
          { required: true, validator: this.$common.formItemVerify, trigger: 'change', msg: '选择重派类型' }
        ],
        firstName: [
          { required: true, validator: this.$common.formItemVerify, trigger: 'blur', msg: '请输入收件人姓名' },
          { required: true, validator: this.$common.formItemVerify, trigger: 'change', msg: '请输入收件人姓名' }
        ],
        province: [
          { required: true, validator: this.$common.formItemVerify, trigger: 'blur', msg: '请输入收件人省州' },
          { required: true, validator: this.$common.formItemVerify, trigger: 'change', msg: '请输入收件人省州' }
        ],
        city: [
          { required: true, validator: this.$common.formItemVerify, trigger: 'blur', msg: '请输入收件人城市' },
          { required: true, validator: this.$common.formItemVerify, trigger: 'change', msg: '请输入收件人城市' }
        ],
        addressLines: [
          { required: true, validator: this.$common.formItemVerify, trigger: 'blur', msg: '请输入收件人地址' },
          { required: true, validator: this.$common.formItemVerify, trigger: 'change', msg: '请输入收件人地址' }
        ],
        postalCode: [
          { required: true, validator: this.$common.formItemVerify, trigger: 'blur', msg: '请输入收件人邮编' },
          { required: true, validator: this.$common.formItemVerify, trigger: 'change', msg: '请输入收件人邮编' }
        ],
        phoneNumber: [
          { required: true, validator: this.$common.formItemVerify, trigger: 'blur', msg: '请输入联系电话' },
          { required: true, validator: this.$common.formItemVerify, trigger: 'change', msg: '请输入联系电话' }
        ],
      }
    };
  },
  watch: {
    modalVisible: {
      immediate: true,
      handler (val) {
        this.abnormalModalVisible = val;
      }
    },
  },
  computed: {
    // 按钮 key
    viewKey () {
      if (this.$common.isEmpty(this.modalData) || this.$common.isEmpty(this.modalData.buttonData)) return '';
      return this.modalData.buttonData.key || '';
    },
    // 按钮数据
    resData () {
      if (this.$common.isEmpty(this.modalData)) return {};
      return this.modalData.resData || {};
    },
    // 异常ID
    abnormalId () {
      if (this.$common.isEmpty(this.modalData)) return '';
      return this.modalData.abnormalId || '';
    },
  },
  methods: {
    // 显示弹窗时
    visibleHand (value) {
      if (!value) return;
      this.$nextTick(() => {
        this.$refs.abnormalFormRef && this.$refs.abnormalFormRef.resetFields();
        this.$nextTick(() => {
          this.formData.extraCodes = '202';
          this.formData.retryType = 1;
        });
      });
    },
    // 放行
    packageRelease () {
      let obj = {
        id: this.abnormalId,
        extraCodes: (this.formData.extraCodes == '202') ? '' : this.formData.extraCodes,
      };
      if (['204', '205'].includes(this.formData.extraCodes)) {
        obj.newWaybillNumbers = this.$common.split(this.formData.newWaybillNumbers, ['，', ',', '\n'], true);
      }
      this.pageLoading = true;
      this.axios.post(api.issueRelease, obj).then((res) => {
        if (!res || !res.data || res.data.code != 0) return;
        this.$Message.success('操作成功');
        this.closeMatchModal(true);
      }).finally(() => {
        this.pageLoading = false;
      });
    },
    // 退回
    packageReturn (type = 2) {
      this.pageLoading = true;
      this.axios.post(`${api.issueHandle}/${this.abnormalId}?handleType=${type}`).then((res) => {
        if (!res || !res.data || res.data.code != 0) return;
        this.$Message.success('操作成功');
        this.closeMatchModal(true);
      }).finally(() => {
        this.pageLoading = false;
      });
    },
    // 换单
    packageSwitch () {
      let obj = {
        id: this.abnormalId,
        newWaybillNumber: this.formData.newWaybillNumber,
      };
      this.pageLoading = true;
      this.axios.post(api.changeWaybillNumber, obj).then((res) => {
        if (!res || !res.data || res.data.code != 0) return;
        this.$Message.success('操作成功');
        this.closeMatchModal(true);
      }).finally(() => {
        this.pageLoading = false;
      });
    },
    // 重派
    packageReassign () {
      let obj = {
        id: this.abnormalId,
        retryType: this.formData.retryType, // 重派类型。枚举(1：原址重派 2：换址重派)
      };
      if ([2, '2'].includes(this.formData.retryType)) {
        obj.firstName = this.formData.firstName;
        obj.province = this.formData.province;
        obj.city = this.formData.city;
        obj.addressLines = this.formData.addressLines;
        obj.postalCode = this.formData.postalCode;
        obj.phoneNumber = this.formData.phoneNumber;
      }
      this.pageLoading = true;
      this.axios.post(api.issueRetryDelivery, obj).then((res) => {
        if (!res || !res.data || res.data.code != 0) return;
        this.$Message.success('操作成功');
        this.closeMatchModal(true);
      }).finally(() => {
        this.pageLoading = false;
      });
    },
    // 弃件
    packageAbandon () {
      this.packageReturn(1);
    },
    // 已读
    packageRead () {
      this.pageLoading = true;
      this.axios.post(`${api.issueRead}/${this.abnormalId}`).then((res) => {
        if (!res || !res.data || res.data.code != 0) return;
        this.$Message.success('操作成功');
        this.closeMatchModal(true);
      }).finally(() => {
        this.pageLoading = false;
      });
    },
    // 忽略
    packageIgnore () {
      this.pageLoading = true;
      this.axios.post(`${api.yuntuIgnore}/${this.abnormalId}`).then((res) => {
        if (!res || !res.data || res.data.code != 0) return;
        this.$Message.success('操作成功');
        this.closeMatchModal(true);
      }).finally(() => {
        this.pageLoading = false;
      });
    },
    // 异常处理
    packageAbnormalHand () {
      this.$refs.abnormalFormRef.validate((valid) => {
        if (!valid) return this.$common.inputFocus('.abnormal-modal-form');
        if (!this[this.viewKey]) return this.$Message.error('暂无该操作流程');
        this[this.viewKey]();
      });
    },
    // 关闭弹窗时，重置数据
    closeMatchModal (type = false) {
      this.abnormalModalVisible = false;
      this.$emit('closeAbnormalModal', type);
    },
  }
};
</script>
<style lang="less" scoped>
.abnormal-modal-main{
  position: relative;
  .abnormal-modal-form{
    position: relative;
    .abnormal-tips-txt{
      padding: 20px 50px;
      font-size: 20px;
      font-weight: bold;
    }
    .abnormal-error-tips {
      color: #f20;
    }
    .two-col-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, calc(50% - 10px));
      gap: 10px;
    }
  }
}
</style>
